import PropTypes from 'prop-types';
import React from 'react';

const Line = ({slice}) => {
  return (
    <section className={slice?.source ?? 'tema line-divider-wrapper'}>
      <div className="line-divider"></div>
    </section>
  );
};

Line.propTypes = {
  slice: PropTypes.object,
};

export default Line;
